var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 7.62697 14.9496 7.74873 14.8598 7.83851C14.77 7.92829 14.6482 7.97872 14.5213 7.97872H11.25H7.97872V14.5213C7.97872 14.6482 7.92829 14.77 7.83851 14.8598C7.74873 14.9496 7.62697 15 7.5 15C7.37303 15 7.25127 14.9496 7.16149 14.8598C7.07171 14.77 7.02128 14.6482 7.02128 14.5213V7.97872H0.478723C0.351758 7.97872 0.229993 7.92829 0.140215 7.83851C0.0504367 7.74873 0 7.62697 0 7.5C0 7.37303 0.0504367 7.25127 0.140215 7.16149C0.229993 7.07171 0.351758 7.02128 0.478723 7.02128H7.02128V0.478723C7.02128 0.351758 7.07171 0.229993 7.16149 0.140215C7.25127 0.0504367 7.37303 0 7.5 0C7.62697 0 7.74873 0.0504367 7.83851 0.140215C7.92829 0.229993 7.97872 0.351758 7.97872 0.478723V7.02128H14.5213C14.6482 7.02128 14.77 7.07171 14.8598 7.16149C14.9496 7.25127 15 7.37303 15 7.5Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.ac189281086a5284b81caa9c9d14a5ec.svg";
export { ForwardRef as ReactComponent };